import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { Actions } from 'Flux/Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import type { Epic } from 'Flux/index.js'

export const MovePoolItemsEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.movePoolItemsRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.movePoolItems(
        {
          orderId: action.payload.orderId,
          sourcePoolId: action.payload.sourcePoolId,
          targetPoolId: action.payload.targetPoolId,
          items: action.payload.items
        },
        state.authentication.user
      ).pipe(
        mergeMap((response) =>
          of(
            order.movePoolItemsRequestSuccess({
              orderId: action.payload.orderId,
              sourcePoolId: action.payload.sourcePoolId,
              targetPoolId: action.payload.targetPoolId,
              items: response,
              itemIds: action.payload.items,
            })
          )
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.movePoolItemsRequestFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error deleting order', error)
          return of(order.movePoolItemsRequestFailure({ error }))
        })
      )
    )
  )
